export enum ANALYTICS_PERMISSIONS {
  SURVEY = 'SURVEY_ANALYTICS',
  AUDIT = 'AUDIT_ANALYTICS',
  BIENSEC_AUDIT = 'BIENSEC_ANALYTICS',
}
